import { ApiRequest } from '../ApiRequest';

export enum GenerateInteractiveQuestionsDefaultLanguage {
  English = 'en',
  Spanish = 'es',
  French = 'fr',
  Brazilian = 'ptBr',
  Italian = 'it',
  German = 'de',
}


export type PostGenerateInteractiveQuestionsRequestBody = {
  topic: string;
  language: GenerateInteractiveQuestionsDefaultLanguage;
};

export type PostGenerateInteractiveQuestionsRequestParams = {
  teamId: string | undefined;
};

export interface PostGenerateInteractiveQuestionsRequest
  extends ApiRequest<
    PostGenerateInteractiveQuestionsRequestBody,
    PostGenerateInteractiveQuestionsRequestParams
  > {}
